import React from 'react';
import parse from 'html-react-parser';

function SoapPrintPopup({ allData }) {
  let demoData = {};

  for (const key in allData?.progressNoteItem) {
    if (allData?.progressNoteItem[key]?.variable_name === 'demographics') {
      for (const subKey in allData?.defaultSaveItem) {
        if (subKey === allData?.progressNoteItem[key]?.id) {
          demoData = allData?.defaultSaveItem[subKey]?.demographics;
          break;
        }
      }
    }
  }
  return (
    <>
      <table
        width="734px"
        align="left"
        valign="top"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ fontSize: '14px', marginBottom: '20px' }}
      >
        <tbody>
          <tr width="734px">
            <td
              align="center"
              width="734px"
              style={{ fontSize: '21px', color: '#000' }}
            >
              {allData?.typeOfVisit}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        cellSpacing={0}
        cellPadding={0}
        border={0}
        align="center"
        style={{ paddingBottom: '10px' }}
      >
        <tbody>
          <tr width="734px">
            <td width="407px" style={{ paddingTop: '10px' }} valign="top">
              <table
                width="407px"
                align="left"
                border={0}
                cellSpacing={0}
                cellPadding={0}
              >
                <tbody>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ fontSize: '27px' }}>
                      {demoData?.patientName}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td
                      valign="top"
                      width="407px"
                      style={{ paddingTop: '10px', fontSize: '13px' }}
                    >
                      Chart ID: {demoData?.chartNo}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td
                      valign="top"
                      width="407px"
                      style={{ paddingTop: '20px', fontSize: '13px' }}
                    >
                      {demoData?.age} {demoData?.gender} | <b>DOB:</b>{' '}
                      {demoData?.dob}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td
                      valign="top"
                      width="407px"
                      style={{ paddingTop: '10px', fontSize: '13px' }}
                    >
                      <b>Add:</b> {demoData?.address}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td
                      valign="top"
                      width="407px"
                      style={{ paddingTop: '10px', fontSize: '13px' }}
                    >
                      Email: {demoData?.email} | <b>{demoData?.phoneLabel}:</b>{' '}
                      {demoData?.phone ? `${demoData?.phone}` : ''}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td
                      valign="top"
                      width="407px"
                      style={{ paddingTop: '10px', fontSize: '13px' }}
                    >
                      <b>Race:</b> {demoData?.race} | <b>Ethnicity:</b>{' '}
                      {demoData?.ethincity}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td width="327px" style={{ paddingTop: '10px' }} valign="top">
              <table
                width="327px"
                align="left"
                border={0}
                cellSpacing={0}
                cellPadding={0}
                valign="top"
              >
                <tbody>
                  <tr rowSpan={2} width="327px">
                    <td
                      valign="top"
                      width="120px"
                      style={{ paddingTop: '20px', fontSize: '13px' }}
                    >
                      <b>Provider:</b>
                    </td>
                    <td
                      valign="top"
                      width="207px"
                      style={{ paddingTop: '20px', fontSize: '13px' }}
                    >
                      {allData?.counselorName}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td
                      valign="top"
                      width="120px"
                      style={{ paddingTop: '7px', fontSize: '13px' }}
                    >
                      <b>Supervisor:</b>
                    </td>
                    <td
                      valign="top"
                      width="207px"
                      style={{ paddingTop: '7px', fontSize: '13px' }}
                    >
                      {allData?.providerName}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td
                      valign="top"
                      width="120px"
                      style={{ paddingTop: '7px', fontSize: '13px' }}
                    >
                      <b>Date of service:</b>
                    </td>
                    <td
                      valign="top"
                      width="207px"
                      style={{ paddingTop: '7px', fontSize: '13px' }}
                    >
                      {allData?.dateOfVisit}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td
                      valign="top"
                      width="120px"
                      style={{ paddingTop: '7px', fontSize: '13px' }}
                    >
                      <b>Type of visit:</b>
                    </td>
                    <td
                      valign="top"
                      width="207px"
                      style={{ paddingTop: '7px', fontSize: '13px' }}
                    >
                      {allData?.typeOfVisit}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      {allData?.telemedicineInfo === '1' && (
        <table
          width="734px"
          align="left"
          border={0}
          cellSpacing={0}
          cellPadding={0}
          style={{ marginTop: '15px', paddingBottom: '10px' }}
        >
          <tbody>
            <tr width="734px">
              <td
                valign="top"
                width="334px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                Telemedicine (Audio &amp; Video):
              </td>
              <td
                valign="top"
                width="400px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                {allData?.telemedDetail?.mode}
              </td>
            </tr>
            <tr width="734px">
              <td
                valign="top"
                width="334px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                Patient's Physical location:
              </td>
              <td
                valign="top"
                width="400px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                {allData?.telemedDetail?.patLocStr}
              </td>
            </tr>
			{allData?.telemedDetail?.patLocAddressStr ? (
              <tr width="734px">
                <td
                  valign="top"
                  width="334px"
                  style={{ paddingTop: '10px', fontSize: '13px' }}
                >
                  Patient location detail:
                </td>
                <td
                  valign="top"
                  width="400px"
                  style={{ paddingTop: '10px', fontSize: '13px' }}
                >
                  {allData?.telemedDetail?.patLocAddressStr}
                </td>
              </tr>
            ) : null}
            <tr width="734px">
              <td
                valign="top"
                width="334px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                Provider's Physical location:
              </td>
              <td
                valign="top"
                width="400px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                {allData?.telemedDetail?.proLocStr}
              </td>
            </tr>
            <tr width="734px">
              <td
                valign="top"
                width="334px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                Patient/Family aware of the provider's location:
              </td>
              <td
                valign="top"
                width="400px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                {allData?.telemedDetail?.pfaProviderLocStr}
              </td>
            </tr>
            <tr width="734px">
              <td
                valign="top"
                width="334px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                Patient/Family consent for Telemedicine:
              </td>
              <td
                valign="top"
                width="400px"
                style={{ paddingTop: '10px', fontSize: '13px' }}
              >
                {allData?.telemedDetail?.pfaTelemedicineStr}
              </td>
            </tr>
          </tbody>
        </table>
      )}
      {(() => {
        let newArray = allData?.saveItemList.filter(
          (obj) => obj.section_value !== ''
        );
        return (
          allData?.progressNoteItem &&
          allData?.saveItemList &&
          newArray.map((section, index) => (
            <React.Fragment key={index}>
              {allData?.progressNoteItem.map((item, i) =>
                item?.id === section?.section_id ? (
                  item?.variable_name !== 'demographics' ? (
                    <table
                      key={i}
                      width="734px"
                      align="left"
                      border={0}
                      cellSpacing={0}
                      cellPadding={0}
                      style={{ marginTop: '15px', paddingBottom: '10px' }}
                    >
                      <thead>
                        <tr width="734px">
                          <th
                            width="734px"
                            style={{ fontSize: '17px', color: '#000' }}
                            align="left"
                          >
                            {item?.preferred_label}:
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr width="734px">
                          <td
                            width="719px"
                            style={{
                              fontSize: '13px',
                              color: '#000',
                              paddingTop: '5px',
                              lineHeight: '21px',
                            }}
                          >
                            {parse(section?.section_value)}
                            {/* <span
                              dangerouslySetInnerHTML={{
                                __html: section?.section_value,
                              }}
                            /> */}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : null
                ) : null
              )}
            </React.Fragment>
          ))
        );
      })()}
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: '0px', paddingBottom: '10px' }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: '13px', color: '#000' }}
              align="left"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontSize: '13px',
                color: '#000',
                paddingTop: '5px',
                lineHeight: '21px',
                fontStyle: 'italic',
              }}
            >
              {allData?.addendumList && allData?.addendumList.length > 0 && (
                <div
                  className="addendumBlock"
                  style={{ whiteSpace: 'pre-line' }}
                >
                  <p style={{ marginLeft: '9px', marginTop: '30px' }}>
                    <strong>Addendum:</strong>
                  </p>
                  {allData?.addendumList?.map((item, i) => {
                    return (
                      <div key={i}>
                        <p style={{ marginLeft: '9px' }}>
                          <b>Provider Name & Credentials: </b>{' '}
                          {item?.ProviderDetail} <br />
                          <b>Original Note Date: </b> {item?.originalNote}{' '}
                          <br />
                          <b>Addendum Date: </b> {item?.addendumDate} <br />
                          <b>Added By: </b> {item?.addedBy} <br />
                          <b>Reason for Addendum: </b> <br />
                          <span
                            dangerouslySetInnerHTML={{ __html: item?.reason }}
                          />{' '}
                          <br />
                          <b>Additional Information: </b> <br />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          />
                        </p>
                        <br />
                      </div>
                    );
                  })}
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: '0px', paddingBottom: '10px' }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: '13px', color: '#000' }}
              align="left"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontSize: '13px',
                color: '#000',
                paddingTop: '5px',
                lineHeight: '21px',
                fontStyle: 'italic',
              }}
            >
              {/* {parse(allData?.printHeaderFooterInfo?.signDetail?.signStr)} */}
              {/* I have reviewed &amp; discussed the case &amp; the care goal plan
              with Jeanne Chutuape, PMHNP. I am signing as a responsible &amp;
              billing provider. Co-Signed by <b>Harish Goyal, MD</b>, 1:19 pm
              Jun 12, 2024 */}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default SoapPrintPopup;
